/** @format */

import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UpdatePasswordForm } from '../components/UpdatePasswordForm';

/**
 * UpdatePasswordContainer
 * Container component for the update password flow
 */
export const UpdatePasswordContainer: React.FC = () => {
  return (
    <>
      <UpdatePasswordForm />
      <ToastContainer />
    </>
  );
};

export default UpdatePasswordContainer;
